import moment from "moment";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { Button, Col, Modal, ModalBody, ModalHeader } from "reactstrap";
import Loader from "src/components/Loader";
import { approvedPackage } from "src/store/dashboard/saga";
import { DashboardClientPurchasedPackageDetailDto } from "src/store/dashboard/type";
import { TicketDetailDto } from "src/store/ticket/type";

const ApprovalModal = ({
  selected,
  show,
  setShow,
  onSuccess,
  ticket,
}: {
  onSuccess: () => void;
  selected: DashboardClientPurchasedPackageDetailDto;
  show: boolean;
  setShow: (show: boolean) => void;
  ticket: TicketDetailDto;
}) => {
  const { t } = useTranslation();
  const [loader, setLoader] = useState(false);
  const approved = (approved: boolean) => {
    setLoader(true);
    dispatch(
      approvedPackage({
        payload: {
          onSuccess: (message) => {
            toast.success(message, { theme: "colored" });
            setShow(false);
            setLoader(false);
            onSuccess();
          },
          onError: (message) => {
            toast.error(message, {
              theme: "colored",
            });
          },
        },
        body: {
          PurchasedPackageId: selected.Id,
          Approved: approved,
        },
      })
    );
  };
  const dispatch = useDispatch();
  return (
    <React.Fragment>
      <Modal isOpen={show} toggle={() => setShow(false)}>
        <ModalHeader toggle={() => setShow(false)}></ModalHeader>
        <ModalBody>
          {loader && <Loader />}
          <div className="d-flex justify-content-end mb-1">
            <Button
              color="light"
              type="submit"
              onClick={() => {
                window.open("/ticket/all?ticketId=" + ticket.Id, "_blank");
              }}
            >
              {t("Dashboard.OpenTicket")}
            </Button>
          </div>
          <Col md={12}>
            <table className="pack-table w-100">
              <tr>
                <th>{t("Dashboard.Package")}:</th>
                <td>
                  {selected.PackageName}
                  <i
                    className="bx bx-info-circle"
                    style={{ cursor: "pointer" }}
                    onClick={() => setShow(true)}
                  />
                </td>
              </tr>
              <tr>
                <th>{t("Dashboard.PurchaseDate")}:</th>
                <td>
                  {moment(selected.PurchaseDate).format("DD/MM/YYYY HH:mm:ss")}
                </td>
              </tr>
              <tr>
                <th>{t("Dashboard.PackStartDate")}:</th>
                <td>
                  {moment(selected.PackStratDate).format("DD/MM/YYYY HH:mm:ss")}
                </td>
              </tr>
              <tr>
                <th>{t("Dashboard.PackEndDate")}:</th>
                <td>
                  {moment(selected.PackEndDate).format("DD/MM/YYYY HH:mm:ss")}
                </td>
              </tr>
              <tr>
                <th>{t("Dashboard.Amount")}:</th>
                <td>{selected.Amount}</td>
              </tr>
            </table>
          </Col>
          <div className="d-flex justify-content-between mt-5">
            <Button
              color="danger"
              type="submit"
              onClick={() => {
                return approved(false);
              }}
            >
              {t("Dashboard.ApprovePayment")}
            </Button>
            <Button
              color="success"
              type="submit"
              onClick={() => {
                return approved(true);
              }}
            >
              {t("Dashboard.RejectPayment")}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};
export default ApprovalModal;
